import { render, staticRenderFns } from "./PotentialCustomers.vue?vue&type=template&id=873a3404&"
import script from "./PotentialCustomers.vue?vue&type=script&lang=js&"
export * from "./PotentialCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports